import React, { useState } from 'react';
 import { useAuth } from '../context/AuthContext'; // Use your AuthContext
 import { sendEmailVerification } from 'firebase/auth';
 import { auth } from '../firebase'; // Import auth instance if needed for signout
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 import { faEnvelope, faExclamationTriangle, faCheckCircle, faSync, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

 function EmailVerificationPrompt() {
   const { currentUser } = useAuth();
   const [message, setMessage] = useState('');
   const [error, setError] = useState('');
   const [loading, setLoading] = useState(false);
   const [refreshing, setRefreshing] = useState(false);

   const handleResendVerification = async () => {
     setError('');
     setMessage('');
     if (!currentUser) {
       setError('Not logged in.');
       return;
     }

     setLoading(true);
     try {
       await sendEmailVerification(currentUser);
       setMessage('Verification email sent! Please check your inbox (and spam folder).');
     } catch (err) {
       console.error("Error sending verification email:", err);
       setError(`Failed to send verification email: ${err.message}`);
     } finally {
       setLoading(false);
     }
   };

   const handleRefresh = async () => {
     if (!currentUser) return;
     setRefreshing(true);
     try {
       await currentUser.reload();
       // A full page reload is the most reliable way to trigger the auth state listener
       // which will then grant access to the rest of the application.
       window.location.reload();
     } catch (err) {
       console.error("Error reloading user:", err);
       setError("Failed to refresh user status. Please try logging out and back in.");
       setRefreshing(false);
     }
   };

   const handleLogout = () => {
     auth.signOut();
   };

   return (
     <div className="container mt-4">
       <div className="row justify-content-center">
         <div className="col-md-8 col-lg-6">
           <div className="card text-center shadow-sm border-warning">
             <div className="card-header bg-warning text-dark">
               <FontAwesomeIcon icon={faExclamationTriangle} className="me-2"/> Email Verification Required
             </div>
             <div className="card-body">
               <p className="card-text">
                 You're almost there! Your email address (<strong>{currentUser?.email}</strong>) has not yet been verified.
               </p>
               <p>
                 Please check your email inbox (and spam folder) for a verification link. After clicking the link to verify, click the refresh button below.
               </p>
               {message && <div className="alert alert-success py-2 small"><FontAwesomeIcon icon={faCheckCircle} className="me-1"/> {message}</div>}
               {error && <div className="alert alert-danger py-2 small"><FontAwesomeIcon icon={faExclamationTriangle} className="me-1"/> {error}</div>}

               {/* --- MODIFIED BUTTON LAYOUT --- */}

               {/* Centered container for primary actions */}
               <div className="text-center mt-3">
                 <button
                   className="btn btn-primary"
                   onClick={handleResendVerification}
                   disabled={loading || refreshing}
                 >
                   {loading ? 'Sending...' : <><FontAwesomeIcon icon={faEnvelope} className="me-2"/>Resend Email</>}
                 </button>
                 <button
                   className="btn btn-primary ms-2"
                   onClick={handleRefresh}
                   disabled={loading || refreshing}
                 >
                   {refreshing ? 'Refreshing...' : <><FontAwesomeIcon icon={faSync} className="me-2"/>Refresh</>}
                 </button>
               </div>

               {/* Right-aligned container for logout, spaced down */}
               <div className="text-end mt-4">
                 <button
                   className="btn btn-danger"
                   onClick={handleLogout}
                 >
                   <FontAwesomeIcon icon={faSignOutAlt} className="me-2"/>
                   Logout
                 </button>
               </div>

             </div>
             <div className="card-footer text-muted small">
               If you've already verified, click the refresh button or try logging out and back in.
             </div>
           </div>
         </div>
       </div>
     </div>
   );
 }

 export default EmailVerificationPrompt;